<div class="steps-indicator mb-4 px-2">
  <div class="steps-line position-absolute top-50 start-0 end-0 translate-middle-y bg-primary"></div>
  <div class="steps-circles position-relative">
    <ng-container *ngFor="let step of steps; let i = index">
      <div
        class="step-circle position-absolute d-flex align-items-center justify-content-center border shadow"
        [ngClass]="{
          'bg-primary text-white border-primary': currentStep >= step,
          'bg-white text-primary border-primary': currentStep < step
        }"
        [style.left]="i === 0 ? '0%' : i === steps.length - 1 ? 'auto' : getStepPosition(i)"
        [style.right]="i === steps.length - 1 ? '0%' : 'auto'"
        [style.transform]="i !== 0 && i !== steps.length - 1 ? 'translateX(-50%)' : ''"
      >
        <ng-container *ngIf="currentStep > step; else stepNumber">
          <i class="bi bi-check"></i>
        </ng-container>
        <ng-template #stepNumber>{{ step }}</ng-template>
      </div>
    </ng-container>
  </div>
</div>
